import React from 'react'
import './Header.scss'

const Header = props => {
    return (
        <h> {props.Section} </h>
    )
}

export default Header